export default __webpack_public_path__ + "static/media/logo.66fdf63e.svg";